var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"bread-crumbs"},[_c('ul',{staticClass:"bcul"},[_c('li',{staticClass:"bcli"},[_c('router-link',{staticClass:"link",attrs:{"to":"/","exact":""}},[_vm._v("SALSE SCOPE")])],1),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }